export default __webpack_public_path__ + "static/media/azure-sql.3f14a0ba.svg";